import { useEffect, useState } from 'react';

/**
 * True on large screens with a fine pointer (desktop + mouse). The reservation
 * floor-plan editor is gated behind this; mobile/touch gets a read-only view.
 */
export function useIsLargeScreen(minWidthPx = 1024): boolean {
  const query = `(min-width: ${minWidthPx}px) and (pointer: fine)`;
  const [matches, setMatches] = useState(() =>
    typeof window !== 'undefined' ? window.matchMedia(query).matches : false,
  );

  useEffect(() => {
    const mql = window.matchMedia(query);
    const onChange = () => setMatches(mql.matches);
    onChange();
    mql.addEventListener('change', onChange);
    return () => mql.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
